/* import __COLOCATED_TEMPLATE__ from './advanced-button.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./advanced-button.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());